import {call, put, take} from 'redux-saga/effects';

import {LessonSparkViewRecordApi} from 'static/three-oh/src/modules/apis';

import * as actions from './../actions/lessonSparkViewRecordActions';
import * as types from './../constants/lessonSparkViewRecordActionTypes';

function * getLessonSparkViewRecords() {
  try {
    const data = yield call(LessonSparkViewRecordApi.getLessonSparkViewRecords);
    yield put(actions.loadLessonSparkViewRecordsSuccess(data));
  } catch (error) {
    yield put(actions.loadLessonSparkViewRecordsFailure(error));
  }
}

export function * watchGetLessonSparkViewRecords() {
  yield take(types.LESSON_SPARK_USER_VIEW_LOAD_REQUEST);
  yield call(getLessonSparkViewRecords);
}
